import { useEffect, useState } from 'react';

export const getOrientation = (): 'portrait' | 'landscape' => {
  return window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';
};

export const useOrientation = () => {
  const [orientation, setOrientation] = useState(getOrientation());

  useEffect(() => {
    const handleResize = () => {
      setOrientation(getOrientation());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return orientation;
};
